<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20"
         height="20" viewBox="0 0 20 20" fill="none">
        <g transform="translate(10 10) scale(1.25)
  translate(-10 -10)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0001 3.87891C10.2285 3.87891 10.4371
  4.00857 10.5382 4.21338L12.1906 7.5617L15.8864
  8.09874C16.1124 8.13158 16.3002 8.28988 16.3707
  8.50708C16.4413 8.72427 16.3825 8.96271 16.219
  9.12213L13.5448 11.7291L14.1763 15.4094C14.2149 15.6345
  14.1224 15.862 13.9376 15.9963C13.7529 16.1305 13.5079
  16.1483 13.3058 16.042L10.0001 14.3047L6.69445
  16.042C6.49229 16.1483 6.24734 16.1305 6.0626
  15.9963C5.87785 15.862 5.78534 15.6345 5.82396
  15.4094L6.45541 11.7291L3.78128 9.12213C3.61775 8.96271
  3.55891 8.72427 3.62949 8.50708C3.70007 8.28988 3.88783
  8.13158 4.11384 8.09874L7.80967 7.5617L9.46207
  4.21338C9.56314 4.00857 9.77172 3.87891 10.0001
  3.87891Z"
                fill="#FFCC00"
            />
        </g>
    </svg>
</template>
